import { Gefahr } from '@ps20-frontend/frontend-models';

export const transformGefahrenTHH = (gefahr: Gefahr): Gefahr => {
  if (gefahr.name !== 'THH_PFERD') {
    return gefahr;
  }
  return { ...gefahr, name: 'P' };
};
